var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "rounded-full w-10 h-10 flex items-center justify-center",
        staticStyle: { background: "#1C232A" },
        on: {
          click: function($event) {
            return _vm.$emit("click")
          }
        }
      },
      [
        _c("i", {
          staticClass: "fas text-white",
          class:
            _vm.direction === "right" ? "fa-chevron-right" : "fa-chevron-left"
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }